import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import GradingMachineExcelActions, {
  GradingMachineExcelTypes
} from '../Stores/GradingMachineExcel/Actions';

const getAppStore = state => state.app;

export function* gradingMachineExcelShowBatchJobStatus() {
  try {
    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `batchJobStatus/showBatchJobStatus/GRADING_MACHINE_EXCEL`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        GradingMachineExcelActions.gradingMachineExcelShowBatchJobStatusSuccess(result.data)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  }
}

export function* gradingMachineExcelUploadExcel({ file }) {
  try {
    yield put(GradingMachineExcelActions.gradingMachineExcelUploadLoading(true));

    const app = yield select(getAppStore);

    // eslint-disable-next-line no-undef
    const postData = new FormData();
    postData.append('file', file);

    const getData = {};

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `gradingMachine/uploadProcess`,
      app.token,
      postData,
      getData,
      'multipart/form-data'
    );

    if (result.isSuccess === true) {
      // result.data is total
      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(GradingMachineExcelActions.gradingMachineExcelUploadLoading(false));
  }
}

export function* gradingMachineExcelDownloadExcel() {
  try {
    yield put(GradingMachineExcelActions.gradingMachineExcelUploadLoading(true));

    const app = yield select(getAppStore);

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `gradingMachine/download`,
      app.token,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      FileSaver.saveAs(result.data, 'GRADING_MACHINE_EXCEL.XLSX');
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(GradingMachineExcelActions.gradingMachineExcelUploadLoading(false));
  }
}

export const saga = [
  takeLatest(
    GradingMachineExcelTypes.GRADING_MACHINE_EXCEL_SHOW_BATCH_JOB_STATUS,
    gradingMachineExcelShowBatchJobStatus
  ),
  takeLatest(
    GradingMachineExcelTypes.GRADING_MACHINE_EXCEL_UPLOAD_EXCEL,
    gradingMachineExcelUploadExcel
  ),
  takeLatest(
    GradingMachineExcelTypes.GRADING_MACHINE_EXCEL_DOWNLOAD_EXCEL,
    gradingMachineExcelDownloadExcel
  )
];
